import { GameModel } from '@modules/game/game-model';

const fields  = new GameModel().fields();

export default [
  fields.awayTeam,
  fields.localTeam,
  fields.date,
  fields.hour,
  fields.duration,
  fields.location,
  fields.status,
];
